module.exports = __webpack_public_path__ + "static/media/UI.7b6f64ba.jpg";